<template>
  <div class="app-footer">

    <!-- 备案信息区域 -->
    <div class="record-info">
      <div class="icp-record">
        <div class="icp-link">
          <van-icon name="lock" class="icp-icon" :size="15" />
          <span style="font-size: 14px;">{{ icpText }}</span>
        </div>
      </div>

<!--      <div class="gov-record" v-if="govRecordText">-->
<!--        <a :href="govRecordUrl" target="_blank" class="gov-link">-->
<!--          <van-image-->
<!--              src="https://picsum.photos/id/237/20/20"-->
<!--              alt="公安机关备案图标"-->
<!--              class="gov-icon"-->
<!--          />-->
<!--          <span>{{ govRecordText }}</span>-->
<!--        </a>-->
<!--      </div>-->
    </div>

    <!-- 版权信息 -->
    <div class="copyright">
      {{copyrightText}}
    </div>

    <!-- 底部说明文字 -->
<!--    <div class="disclaimer" v-if="disclaimer">-->
<!--      {{disclaimer}}-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    // ICP备案信息
    icpText: {
      type: String,
      default: '晋ICP备2024048387号-3'
    },
    // 公安机关备案信息
    govRecordText: {
      type: String,
      default: '京公网安备12345678901234号'
    },
    govRecordUrl: {
      type: String,
      default: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12345678901234'
    },
    // 版权信息
    copyrightText: {
      type: String,
      default: 'Copyright © '+new Date().getFullYear()+' 源码绿洲网 版权所有'
    },
    // 免责声明
    disclaimer: {
      type: String,
      default: '数据大多数为自己学习积累成果，少部分为合法的互联网渠道收集和整理，供大家学习参考与交流'
    },
  },
}
</script>

<style scoped>
.app-footer {
  background-color: white;
  padding: 50px 0;
  color: #666;
}

.record-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.icp-record, .gov-record {
  font-size: 22px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.icp-link {
  font-size: 22px;
}

.icp-link, .gov-link {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #666;
  text-decoration: none;
  font-size: 12px;
}

.icp-link:hover, .gov-link:hover {
  color: #1989fa;
}

.icp-icon {
  font-size: 14px;
}

.gov-icon {
  width: 16px;
  height: 16px;
}

.copyright {
  font-size: 24px;
  text-align: center;
  margin-bottom: 8px;
  color: #999;
}

.disclaimer {
  font-size: 22px;
  text-align: center;
  padding: 0 16px 16px;
  line-height: 1.5;
}
</style>
